export const extractDomain = (url: string): string | null => {
  try {
    // Ensure URL has a protocol
    let fullUrl = url;
    if (!url.match(/^https?:\/\//)) {
      fullUrl = 'https://' + url;
    }
    
    const hostname = new URL(fullUrl).hostname;
    
    // Remove www. prefix if present
    const cleanHostname = hostname.replace(/^www\./, '');
    
    // Split into parts and get the domain
    const parts = cleanHostname.split('.').reverse();
    if (parts.length >= 2) {
      return `${parts[1]}.${parts[0]}`;
    }
    return cleanHostname;
  } catch (error) {
    // If URL parsing fails, try to extract domain using regex
    try {
      const match = url.match(/(?:https?:\/\/)?(?:www\.)?([^\/\s]+)/);
      if (match && match[1]) {
        const hostname = match[1];
        const parts = hostname.split('.').reverse();
        if (parts.length >= 2) {
          return `${parts[1]}.${parts[0]}`;
        }
        return hostname;
      }
    } catch (e) {
      // Fallback - return null if we can't extract anything
    }
    return null;
  }
};

export const exportToCSV = (submissions: any[], fields: any[], formName: string) => {
  if (submissions.length === 0 || fields.length === 0) {
    alert('No data to export.');
    return;
  }

  const orderedFields = [...fields].sort((a, b) => a.order_index - b.order_index);
  const headers = ['Submitted At', ...orderedFields.map(f => f.label)];
  const csvRows = [headers.join(',')];

  for (const submission of submissions) {
    const values = [
      new Date(submission.submitted_at).toLocaleString(),
      ...orderedFields.map(field => {
        const value = submission.field_responses[field.id] || '';
        return `"${value.replace(/"/g, '""')}"`;
      })
    ];
    csvRows.push(values.join(','));
  }

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${formName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_submissions.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const generateEmbedUrl = (formId: string): string => {
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const protocol = window.location.protocol;
    
    // For localhost development
    if (currentHost.includes('localhost')) {
      return `${protocol}//localhost:3001/#/embed/${formId}`;
    }
    
    // For custom domains (not pages.dev), use domain-based logic
    if (!currentHost.includes('pages.dev')) {
      let embedHost;
      if (currentHost.startsWith('forms.')) {
        // forms.example.com -> embed.example.com
        embedHost = currentHost.replace(/^forms\./, 'embed.');
      } else {
        // example.com -> embed.example.com (assume admin is on root domain)
        embedHost = `embed.${currentHost}`;
      }
      return `${protocol}//${embedHost}/#/embed/${formId}`;
    }
    
    // For pages.dev domains (staging/development), use the specific embed app URL
    return `${protocol}//289866a0.formcraft-public-embed.pages.dev/#/embed/${formId}`;
  }
  return `#/embed/${formId}`;
};

export const generateFormsUrl = (formId: string, page: string = 'edit'): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/#/form/${formId}/${page}`;
  }
  return `#/form/${formId}/${page}`;
};